export default (bm, category, label, type, opts = {}) => {
  const pfx = opts.pfx;
  const style = `
  <style>
  .${pfx} ul, [data-js=${pfx}] ul {
    display: grid;
    grid-template-columns: auto auto auto;
  }
  [data-gjs-type=${pfx}]::after {
    content: "Page List Container"
  }
  </style>
`;
  bm.add(type, {
    label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>
          <div class="gjs-block-label">
          ${label}</div>`,
    category: category,
    content: `
      <div class='${pfx} list-group p-5 width100' style="width:100%" data-js="page-list" data-gjs-type="page-list">
      </div>
      ${style}`,
    render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/cms-component-data-group" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
        </a>
      </span>
    `,
  });
};
